import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../Button';
import { BiEventType } from '../../../biLogger';
export var BuyButton = function (_a) {
    var _b = _a.deviation, deviationId = _b.deviationId, _c = _b.print, _d = _c === void 0 ? {} : _c, lowestPrice = _d.lowestPrice, purchaseUrl = _d.purchaseUrl, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(Button, { view: "b18", className: className, href: purchaseUrl, biData: {
            evid: BiEventType.BUY_CLICK,
            deviationid: deviationId,
        } }, lowestPrice
        ? t('actionbar.buyFor', { price: lowestPrice })
        : t('actionbar.buy')));
};
BuyButton.displayName = 'BuyButton';
export default BuyButton;
//# sourceMappingURL=BuyButton.js.map